import ApexCharts from 'apexcharts'

export class ChartData {
    public constructor(init?: Partial<ChartData>) {
        Object.assign(this, init)
    }
    type: 'bars' | 'donut' | 'line'
    title: string
    series: ChartBarsSeries[] | number[] | any = []
    headline?: string = ''
    categories?: string[] = []
    legendPosition?: 'top' | 'left' | 'right' | 'bottom' = 'top'
    colors?: string[] = undefined
    stacked?: boolean = false
    height?: number = 400
    showTotals: boolean = true
    showGrid: boolean = false
    showToolbar: boolean = false
}

export interface ChartBarsSeries {
    name?: string[]
    data: number[]
    type?: 'bar' | 'line'
}

export class ChartService {
    chart: ApexCharts
    bars(data: ChartData, container) {
        if (!data.colors) data.colors = ['#379E75']
        if (!data.legendPosition) data.legendPosition = 'top'
        const options = {
            colors: data.colors,
            series: data.series,
            chart: {
                type: 'bar',
                height: data.height || 300,
                parentHeightOffset: 0,
                stacked: data.stacked,
                toolbar: {
                    show: false,
                },
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '75%',
                    endingShape: 'flat',
                    dataLabels: {
                        total: {
                            enabled: true,
                            style: {
                                color: '#eee',
                            },
                        },
                    },
                },
            },
            legend: {
                position: data.legendPosition,
                offsetY: 15,
                labels: {
                    colors: '#999',
                },
            },
            dataLabels: {
                enabled: true,
            },
            stroke: {
                show: true,
                width: 2,
                colors: ['transparent'],
            },
            grid: {
                show: data.showGrid,
                borderColor: '#99999930',
            },
            xaxis: {
                categories: data.categories,
                labels: {
                    show: true,
                    style: {
                        colors: '#666',
                    },
                },
                axisBorder: {
                    show: true,
                },
                axisTicks: {
                    show: false,
                },
            },
            yaxis: {
                labels: {
                    show: false,
                },
                decimalsInFloat: 0,
            },
            fill: {
                opacity: 1,
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return val
                    },
                },
            },
        }

        if (this.chart) {
            this.chart.updateOptions(options, false, true)
        } else {
            this.chart = new ApexCharts(container, options)
            this.chart.render()
        }
    }

    line(data: ChartData, container) {
        if (!data.colors) data.colors = ['#379E75']
        if (!data.legendPosition) data.legendPosition = 'top'
        const options = {
            colors: data.colors,
            series: data.series,
            chart: {
                type: 'line',
                height: data.height || 300,
                stacked: data.stacked,
                toolbar: {
                    show: data.showToolbar,
                },
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '75%',
                    endingShape: 'flat',
                    dataLabels: {
                        style: {
                            fontSize: '14px',
                        },
                        total: {
                            enabled: data.showTotals,
                            style: {
                                fontSize: '14px',
                                color: '#eee',
                            },
                        },
                    },
                },
            },
            legend: {
                position: data.legendPosition,
                offsetY: 15,
                labels: {
                    colors: '#999',
                },
            },
            dataLabels: {
                enabled: true,
            },
            stroke: {
                show: true,
                width: 3,
            },
            grid: {
                show: data.showGrid,
                borderColor: '#99999930',
            },
            xaxis: {
                categories: data.categories,
                labels: {
                    show: true,
                    style: {
                        colors: '#666',
                    },
                },
                axisBorder: {
                    show: true,
                },
                axisTicks: {
                    show: true,
                },
            },
            yaxis: {
                labels: {
                    show: false,
                },
                decimalsInFloat: 0,
            },
            fill: {
                opacity: 1,
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return val
                    },
                },
            },
        }

        if (this.chart) {
            this.chart.updateOptions(options, false, true)
        } else {
            this.chart = new ApexCharts(container, options)
            this.chart.render()
        }
    }

    donut(data: ChartData, container) {
        if (!data.legendPosition) data.legendPosition = 'top'
        const options = {
            colors: data.colors,
            series: data.series,
            chart: {
                type: 'donut',
                height: data.height || 300,
                stacked: data.stacked,
                toolbar: {
                    show: data.showToolbar,
                },
            },
            plotOptions: {},
            labels: data.categories,
            dataLabels: {
                enabled: true,
            },
            stroke: {
                show: true,
                width: 3,
                colors: ['transparent'],
            },
            legend: {
                position: data.legendPosition,

                labels: {
                    colors: ['#999'],
                },
            },
        }

        if (this.chart) {
            this.chart.updateOptions(options, false, true)
        } else {
            this.chart = new ApexCharts(container, options)
            this.chart.render()
        }
    }
}
